import {useOutletContext} from "react-router";
import Grid from "@mui/material/Grid2";
import {MeasurePanel} from "../components/MeasurePanel";
import {MarginWaterfall} from "./MarginWaterfall";

export const WaterfallContainer = () => {
    const {filters} = useOutletContext();

    return (
        <div style={{marginTop: 30, marginBottom: 100}}>
            <Grid container justifySelf="center" spacing={2}>
                <Grid size={4} justifyItems="center">
                    <MeasurePanel filters={filters} initialType="net_price" minimal={true}/>
                </Grid>
                <Grid size={4} justifyItems="center">
                    <MeasurePanel filters={filters} initialType="pocket_price_margin_per_unit" minimal={true}/>
                </Grid>
                <Grid size={4} justifyItems="center">
                    <MeasurePanel filters={filters} initialType="pocket_price_margin_percent" minimal={true}/>
                </Grid>
                <Grid size={12} justifyItems="center">
                    <MarginWaterfall filters={filters}/>
                </Grid>
            </Grid>
        </div>
    );
};